<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <KTCodePreview>
                    <template v-slot:body>
                        <div id="pdf-content">
                            <div class="row" style="height: 50px; margin-top: 5%;">
                                <br>
                                <v-data-table :headers="headers" :items="lecturers" :hide-default-footer="true"
                                    disable-pagination class="mt-8" style="margin-bottom: 60px;">
                                    <!-- <template v-slot:item.credits="{ item }">
                      <div style="text-align: center; margin-left: -20px !important;">{{ item.credits }}</div>
                    </template> -->
                                    <template v-slot:item.no="{ item, index }">
                                        {{ item.no }}
                                    </template>
                                </v-data-table>
                            </div>
                        </div>

                    </template>
                </KTCodePreview>
            </div>
        </div>
    </div>
</template>
  
<script>
import KTCodePreview from "@/view/content/CardContent.vue";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
// import ButtonComponent from "@/view/content/components/button/buttonComponent.vue";
import axios from "axios";

export default {
    data() {
        return {
            headers: [
                { text: "No", align: "center", value: "no" },
                { text: "NID", value: "nidn" },
                { text: "Nama Dosen", value: "name" },
                { text: "Pangkat", value: "rank" },
                { text: "Prodi Homebased", value: "prodi_homebased" },
                { text: "Pendidikan", value: "pendidikan" }
            ],
            lecturers: [],
        };
    },
    components: {
        KTCodePreview,
        // ButtonComponent,
    },
    async mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "DOSEN" },
        ]);
        await this.getData();
        await this.printData();
    },
    methods: {

        async printData() {

            var printContents = document.getElementById('pdf-content').innerHTML;
            document.body.innerHTML = printContents;
            window.print();
        },
        async getData() {
            this.lecturers = []
            const result = await axios.get(`master/lecturers`)
            if (result.data.meta.code == 200) {
                result.data.data.map((lect, index) => {
                    let obj = {}
                    if (lect.nidn == 'null' || lect.nidn == null) {
                        lect.nidn = ''
                    }
                    if (lect.pendidikan_terakhir !== null) {
                        obj = {
                            no: index + 1,
                            nidn: lect.nidn,
                            name: lect.name,
                            rank: lect.rank,
                            prodi_homebased: lect.nama_prodi,
                            pendidikan: lect.pendidikan_terakhir.education,
                        };
                    } else {
                        obj = {
                            no: index + 1,
                            nidn: lect.nidn,
                            name: lect.name,
                            rank: lect.rank,
                            prodi_homebased: lect.nama_prodi,
                        };
                    }
                    this.lecturers.push(obj);
                });
            }
        },

    },
};
</script>
<style>
@media print {
    body {
        transform: scale(1);
    }
}

.card-krs {
    border-left: 2px solid #485377;
}

.card-krs span {
    color: #485377;
    font-size: initial;
}

.card-krs p {
    color: #485377;
    font-weight: 700;
    font-size: initial;
}

.header-krs-color {
    font-size: inherit !important;
    font-weight: 700 !important;
    color: black !important;
    border-top: 2px solid;
    border-bottom: 2px solid !important;
    height: 35px !important;
}

.v-card-krs>*:first-child:not(.v-btn):not(.v-chip):not(.v-avatar),
.v-card>.v-card__progress+*:not(.v-btn):not(.v-chip):not(.v-avatar) {
    border-top: 1px solid #485377;
}

.border-krs {
    /* border-top: 2px solid #3751E4;
  border-bottom: 2px solid #3751E4;  */
}

.p-krs {
    margin: 2px 0px 0px 20px;
    font-weight: 700;
    color: #485377;
    font-size: initial;
}

/* tr { border: 2px solid red; } */
.color-font {
    color: #485377;
}

.v-data-table>.v-data-table__wrapper>table>tbody>tr>td {
    /* font-size: small; */
    height: 40px;
}

.v-data-table>.v-data-table__wrapper>table>tbody>tr>th {
    font-size: inherit !important;
    height: 40px;
    font-weight: 600;
}

.btn-krs {
    /* width: 40px;
  height: 40px; */
    background-color: #3751E4 !important;
    margin-right: 2%;
    color: white !important;
    font-weight: 600;
}

.wi {
    width: 100px;
}

.pa {
    padding-bottom: 10px;
}

.wi200 {
    width: 233px;
}

.wi400 {
    width: 400px;
}

.tc {
    text-align: center;
}

.judul {
    font-family: auto;
    font-weight: bolder;
}</style>
